import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref, watch, onMounted, onUnmounted, computed } from 'vue';
import DeviceSelect from './DeviceSelect.vue';
import VideoProfile from './VideoProfile.vue';
import TuiSwitch from './base/TuiSwitch.vue';
import { useBasicStore } from '../../stores/basic';
import { useI18n } from '../../locales';

import useGetRoomEngine from '../../hooks/useRoomEngine';
import { TRTCVideoMirrorType, TRTCVideoRotation, TRTCVideoFillMode } from '@tencentcloud/tuiroom-engine-js';
import { isElectron, isMobile }  from '../../utils/environment';
import { storeToRefs } from 'pinia';
interface Props {
  withPreview?: boolean,
  withMore?: boolean,
  withMirror?: boolean,
  theme?: 'white' | 'black',
}

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoSettingTab',
  props: {
    withPreview: { type: Boolean },
    withMore: { type: Boolean },
    withMirror: { type: Boolean },
    theme: null
  },
  setup(__props: any) {

const props = __props as {
  withPreview?: boolean,
  withMore?: boolean,
  withMirror?: boolean,
  theme?: 'white' | 'black',
}

const roomEngine = useGetRoomEngine();



const basicStore = useBasicStore();
const { isLocalStreamMirror } = storeToRefs(basicStore);

const themeClass = computed(() => (props.theme ? `tui-theme-${props.theme}` : ''));

watch(isLocalStreamMirror, async (val: boolean) => {
  const trtcCloud = roomEngine.instance?.getTRTCCloud();
  if (!isMobile) {
    await trtcCloud?.setLocalRenderParams({
      mirrorType: val
        ? TRTCVideoMirrorType.TRTCVideoMirrorType_Enable : TRTCVideoMirrorType.TRTCVideoMirrorType_Disable,
      rotation: TRTCVideoRotation.TRTCVideoRotation0,
      fillMode: TRTCVideoFillMode.TRTCVideoFillMode_Fill,
    });
  }
});

const { t } = useI18n();

/**
 * Click [More Camera Settings].
 *
 * 点击【更多摄像头设置】
**/
function handleMoreCameraSetting() {
  basicStore.setShowSettingDialog(true);
  basicStore.setActiveSettingTab('video');
}

if (props.withPreview) {
  onMounted(async () => {
    roomEngine.instance?.startCameraDeviceTest({ view: 'test-camera-preview' });
    if (isElectron) {
      // Electron 需要首次设置 mirrorType
      const trtcCloud = roomEngine.instance?.getTRTCCloud();
      await trtcCloud?.setLocalRenderParams({
        mirrorType: isLocalStreamMirror.value
          ? TRTCVideoMirrorType.TRTCVideoMirrorType_Enable : TRTCVideoMirrorType.TRTCVideoMirrorType_Disable,
        rotation: TRTCVideoRotation.TRTCVideoRotation0,
        fillMode: TRTCVideoFillMode.TRTCVideoFillMode_Fill,
      });
    }
  });

  onUnmounted(() => {
    roomEngine.instance?.stopCameraDeviceTest();
  });
}


return { __sfc: true,roomEngine, props, basicStore, isLocalStreamMirror, themeClass, t, handleMoreCameraSetting, DeviceSelect, VideoProfile, TuiSwitch }
}

})